import type { CustomAttributeData } from '@risksmart-app/domain/src/types/common.types';
import type { TestType } from '@risksmart-app/domain/src/types/consts/test-type';
import type { InsertInternalAuditTestResultMutation } from '@risksmart-app/web-graphql-client/generated/graphql';
import { InsertInternalAuditTestResultDocument } from '@risksmart-app/web-graphql-client/generated/graphql';

import { createMutationHook } from '@/utils/hook-factories';

export type InsertControlTestInternalAuditResultInput = {
  InternalAuditReportId: string;
  ControlIds: string[];
  Title?: string | null;
  TestType?: TestType | null;
  Description?: string | null;
  DesignEffectiveness?: number | null;
  PerformanceEffectiveness?: number | null;
  OverallEffectiveness?: number | null;
  Submitter: string;
  TestDate?: string | null;
  CustomAttributeData?: CustomAttributeData | null;
};

export const useInsertControlTestInternalAuditResult = createMutationHook({
  name: 'insertControlTestInternalAuditResult',
  mutationOptions: (trpc, onSuccess) =>
    trpc.frontend.internalAuditResult.insertControlTest.mutationOptions({
      onSuccess,
    }),
  mapInput: (input: InsertControlTestInternalAuditResultInput) => input,
  mapResponse: (result: {
    Ids: string[];
  }): InsertInternalAuditTestResultMutation => ({
    insertChildControlTestInternalAuditResult: {
      __typename: 'insertControlTestResultOutput',
      Ids: result.Ids,
    },
  }),
  invalidate: (trpc) => [
    trpc.frontend.internalAuditResult.pathKey(),
    trpc.frontend.assessment.internalAuditResultCount.queryKey(),
    // COI-889: the internal-audit ratings table on the control Performance tab
    // reads these two routers; nothing in the repo invalidated either.
    trpc.frontend.testResult.pathKey(),
    trpc.frontend.internalAuditTestResult.pathKey(),
    // COI-471 parity: Apollo twin also evicts `internal_audit_report`.
    trpc.frontend.internalAuditReport.pathKey(),
    // COI-471 parity: Apollo twin also evicts `control`.
    trpc.frontend.control.pathKey(),
  ],
  graphqlDocument: InsertInternalAuditTestResultDocument,
  graphqlVariables: (input: InsertControlTestInternalAuditResultInput) => ({
    ...input,
  }),
  evictFields: ['control_test_internal_audit_result', 'internal_audit_report'],
});
